/**
 * @file Work slip relation (for SpendTimes)
 * @author Maarten Lensink
 */
import * as tslib_1 from "tslib";
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from '../../core/dialog.service';
import { AlertsService } from '../../core/alerts.service';
import { RelationBase } from '../../base/relation/relation.base';
import { OverlayService } from '../../core/overlay.service';
import { LocalStorageService } from '../../core/local-storage.service';
import { WorkSlipsService } from '../workslips.service';
import { EventsService } from '../../core/event.service';
import { UserService } from '../../user.service';
import { ActionService } from '../../core/action.service';
var WorkSlipRelationComponent = /** @class */ (function (_super) {
    tslib_1.__extends(WorkSlipRelationComponent, _super);
    /**
     * Constructs a work slip relation component.
     * @param configurationsService Service to get the configuration of this component.
     * @param workSlipsService Service to load and save entity data.
     * @param dialogService Service for displaying dialogs.
     * @param alertsService Service for publish alerts.
     * @param route The active route.
     */
    function WorkSlipRelationComponent(userService, workSlipsService, dialogService, alertsService, translateService, router, overlayService, localStorageService, route, eventsService, actionService) {
        return _super.call(this, userService, workSlipsService, dialogService, alertsService, translateService, router, overlayService, localStorageService, route, eventsService, actionService) || this;
    }
    /**
     * Method to retrieve the requested entities from the backend api.
     * @returns {Observable<QueryResult>} An Observable object that retrieves the requested entities.
     */
    WorkSlipRelationComponent.prototype.refresh = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.master == null) {
                    // Soms heb je dynamische parameter waarden nodig van de master.
                    // Daarom stellen we de master nu verplicht
                    return [2 /*return*/, null];
                }
                if (this.master.entityAspect.entityState.isAdded()) {
                    // Fix issue: Werkbon toont de spendtimes niet (Van Meeuwen) #2594
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, _super.prototype.refresh.call(this)];
            });
        });
    };
    return WorkSlipRelationComponent;
}(RelationBase));
export { WorkSlipRelationComponent };
